<section *ngIf="auth.getUsuario">
  <app-mainavbar [idRol]="auth.getUsuario.fk_rol" [idNivel]="auth.getUsuario.fk_nivel"></app-mainavbar>
  <div class="flex flex-wrap justify-content-evenly">
    <!-- 
    <p-card [header]="'Productos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
      <p class="m-0" (click)="recargarInformacion()">
        <a [routerLink]="['./productos']"> {{totalProductos }} </a>
      </p>
    </p-card>
-->
    <p-card [header]="'Casos Clinicos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
      <p class="m-0" (click)="recargarInformacion()">
        <a [routerLink]="['./casosclinicos']">{{totalCasosClinicos}}</a>
      </p>
    </p-card>
    <p-card [header]="'Puntos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
      <p class="m-0" (click)="recargarInformacion()">
        {{totalPuntos}}
      </p>
    </p-card>
    <p-card [header]="'Saldo'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
      <p class="m-0" (click)="recargarInformacion()">
        <a [routerLink]="['./saldo']"> {{saldo}}</a>
      </p>
    </p-card>

  </div>

  <router-outlet></router-outlet>

</section>